import React, { FC, ReactNode } from "react";
import ContactButton from "../contact-button";

interface HeaderProps {
  icon: string;
  title: string;
  children?: ReactNode;
}

interface Props {
  headerProps?: HeaderProps;
}

const Header: FC<HeaderProps> = ({ icon, title, children }) => (
  <div className="row" style={{ display: "inline-block", width: "100%" }}>
    <div className="page-title">
      <h2 className="m-color-white">
        <i className={`m-icon-item-menu fa-fw fa fa-${icon}`}></i>
        {title}
      </h2>
    </div>

    {children}
  </div>
);

const Page: FC<Props> = ({ headerProps, children }) => (
  <div id="content" role="main">
    {headerProps && <Header {...headerProps} />}
    {children}
    <ContactButton />
  </div>
);

export default Page;
